import React, { createRef } from "react";
import {
  Select,
  Checkbox,
  Table,
  Row,
  Col,
  Button,
  Space,
  DatePicker,
  Dropdown,
  Modal,
  Image,
  Tooltip,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import GeofenceVisitReportStore from "../store/GeofenceVisitReportStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import withRouter from "../withRouter";
import VehicleStore from "../store/VehicleStore";
import dayjs from "dayjs";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import DetailedJobStore from "../store/DetailedJobReportStore";
import DriverLoginReportStore from "../store/DriverLoginReportStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PythonMessageAlert from "./PythonMessageAlert";
import conf from "../config";
import GeofenceReportStore from "../store/GeofenceReportStore";

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};
class GeofenceVisitReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.geofencePOIReportStore = new GeofenceReportStore();
    this.geofenceVisitReportStore = new GeofenceVisitReportStore();
    this.vehicleStore = new VehicleStore();
    this.detailedJobReportStore = new DetailedJobStore(this);
    this.driverLoginStore = new DriverLoginReportStore(this);
    this.pythonMessageRef = createRef();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      selectedVehicles: [],
      selectedgeofenceData: [],
      selectAllVehicles: false,
      selectAllDrivers: false,
      showMonthPopup: false,
      selectAllGeofenceData: false,
      data: "",
      companyId: "",
      fromDate: dayjs().format("YYYY-MM-DD"),
      toDate: dayjs().format("YYYY-MM-DD"),
      Notcompany: false,
      Notasset: false,
      vehicle: false,
      expandedRowKeys: [],
      loadedSummaryData: {},
      selectAllStatus: false,
      status: [],
      innerGridData: [],
      filterValue: "",
      filterNotSelected: false,
      pythonReportMessage: false,
      reportmessage: "",
      toDateNotSelected: false,
      fromDateNotSelected: false,
      selectedColumns: widthAdderFunc([
        {
          title: context.translate("_FLEET_REPORTS_DATE_"),
          dataIndex: "date",
          key: "date",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_REPORTS_GEOFENCELIST_GEOFENCENAME_"),
          dataIndex: "geofenceName",
          key: "geofenceName",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_INTIME_"),
          dataIndex: "inTime",
          key: "inTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
        {
          title: context.translate("_FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_"),
          dataIndex: "outTime",
          key: "outTime",
          width: 100,
          ellipsis: { showTitle: true },
        },
      ]),
    };
    this.ExportMenuProps = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: async (val) => {
        let result = [];
        // console.log(val);
        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            geoZoneId: this.state.selectedgeofenceData.map(Number),
            filterBy: this.state.filterValue,
            driverId: this.state.selectedDrivers,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            language: null,
          };
          if (val.key === "excel") {
            // console.log("afd")
            await this.geofenceVisitReportStore.exportExcel(getData);
            const isSuccess =
              this.geofenceVisitReportStore?.pythonReportMessage === true;
            const isError =
              this.geofenceVisitReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
          if (val.key === "pdf") {
            await this.geofenceVisitReportStore.exportpdf(getData);
            const isSuccess =
              this.geofenceVisitReportStore?.pythonReportMessage === true;
            const isError =
              this.geofenceVisitReportStore?.pythonReportErrorMessage;

            if (isSuccess || isError) {
              await this.setState({
                reportmessage: isSuccess ? "success" : "error",
              });
              await this.triggerReport();
            }
          }
        }
      },
    };
    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });

    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
    await this.setState({ column: this.state.selectedColumns });
  }

  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ companyId: comp?.value });
    await this.setState({
      selectedVehicles: [],
      selectAllVehicles: false,
      selectedgeofenceData: [],
      selectAllGeofenceData: false,
    });

    await this.vehicleStore.getVehiclesCompanyId(comp?.value);

    await this.geofencePOIReportStore.getGeofenceDataByCompany({
      companyId: comp?.value,
    });

    await this.setState({ loadData: 1 });
  }

  getFilteredColumns = () => {
    const { filterValue, selectedColumns } = this.state;

    // If filterValue is "1", exclude the vehicleNo column
    return selectedColumns.filter((col) => {
      if (filterValue === "1" && col.dataIndex === "vehicleNo") return false;
      if (filterValue === "2" && col.dataIndex === "geofenceName") return false;
      return true;
    });
  };

  async handleTableChange(pagination, filters, sorter) {
    // console.log(pagination);
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    // this.handleSearch();
    await this.showData();
  }

  addMonths = (date, months) => {
    // date.setMonth(date.getMonth() + months);
    // date = date + months;
    var indx = dayjs().month() + -6;
    // return date.format("YYYY-MM-DD HH:mm:ss");
    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }

  showData = async () => {
    this.setState({ expandedRowKeys: [] });

    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (this.state.selectedVehicles.length === 0) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.selectedgeofenceData.length === 0) {
      this.setState({ vehicle: true });
    } else {
      this.setState({ vehicle: false });
    }
    if (this.state.filterValue.length === 0) {
      this.setState({ filterNotSelected: true });
    } else {
      this.setState({ filterNotSelected: false });
    }
    if (!this.state.fromDate) {
      this.setState({ fromDateNotSelected: true });
    } else {
      this.setState({ fromDateNotSelected: false });
    }
    if (!this.state.toDate) {
      this.setState({ toDateNotSelected: true });
    } else {
      this.setState({ toDateNotSelected: false });
    }
    if (
      this.state.companyId &&
      // this.state.filterValue.length > 0 &&
      this.state.selectedgeofenceData.length > 0 &&
      this.state.selectedVehicles.length > 0 &&
      this.state.fromDate &&
      this.state.toDate
    ) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false, vehicle: false });
      if (this.checkFromDate(this.state.fromDate)) {
        await this.geofenceVisitReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          // filterBy: this.state.filterValue,
          vehicleId: this.state.selectedVehicles,
          geoZoneId: this.state.selectedgeofenceData.map(Number),
          fromDate: this.state.fromDate,
          toDate: this.state.toDate,
          pageNo: this.state.currentPage,
        });
        await this.setState({ loadData: 1 });
      }
    }
  };

  handleAllSelectVehicles = async (e) => {
    if (this.state.selectAllVehicles) {
      const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId?.map(
        (val) => {
          return val.vehicleId;
        }
      );
      await this.setState({ selectedVehicles: allVehicles });
    } else {
      await this.setState({ selectedVehicles: [] });
    }
  };

  handleSelectAllGeofenceData = async (e) => {
    if (this.state.selectAllGeofenceData) {
      const allGeofenceData = this.geofencePOIReportStore?.geofenceData.map(
        (val) => {
          return val.zoneId;
        }
      );
      await this.setState({ selectedgeofenceData: allGeofenceData });
    } else {
      await this.setState({ selectedgeofenceData: [] });
    }
  };

  handleAllSelectDriver = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.driverLoginStore?.getDrivers?.map((val) => {
        return val.driverId;
      });
      await this.setState({ selectedDrivers: allDrivers });
    } else {
      await this.setState({ selectedDrivers: [] });
    }
  };

  onExpand = async (expanded, record) => {
    // const compositeKey = `${record.vehicleId}|${record.date}`;
    // const expandedRowKeys = expanded ? [record.rowId] : [];
    // this.setState({ expandedRowKeys });

    // if (expanded) {
    //   await this.handleExpandRow(record);
    // }
    this.setState({
    expandedRowKeys: expanded ? [record.row_id] : [],
  });

  //   const expandedRowKeys = expanded ? [record.rowId] : [];
  // this.setState({ expandedRowKeys });

  // if (expanded) {
  //   this.handleExpandRow(record);
  // }
  };

  handleExpandRow = async (record) => {
    // console.log("Got Record",record,this.state.filterValue);
   const innerGridData = record?.tableData || [];

  this.setState((prev) => ({
    innerGridData,
    loadedSummaryData: {
      ...prev.loadedSummaryData,
      [record.row_id]: true,
    },
  }));
    // const compositeKey = `${record.vehicleId}|${record.date}`;
    // if (this.state.filterValue === "1")
    // if (!this.state.loadedSummaryData[record.rowId]) {
    // await this.geofenceVisitReportStore.loadGeofenceVisitSummary({
    //   vehicleId:
    //     this.state.filterValue === "1"
    //       ? this.state.selectedVehicles
    //       : record.vehicleId,
    //   date: record.date,
    //   companyId: this.state.companyId,
    //   filterBy: this.state.filterValue,
    //   geoZoneId:
    //     this.state.filterValue === "1"
    //       ? record.zoneId
    //       : this.state.selectedgeofenceData.map(Number),
    // });
    // this.setState((prevState) => ({
    //   loadedSummaryData: {
    //     ...prevState.loadedSummaryData,
    //     [record.rowId]: true,
    //   },
    // }));
    // }
  };

  handleSelectAllStatus = async () => {
    if (this.state.selectAllStatus) {
      this.setState({
        status: ["4", "3", "6", "8", "7"],
      });
    } else {
      this.setState({
        status: [],
      });
    }
  };

  getExpandedColumns = () => {
    const { filterValue } = this.state;

    const allColumns = [
      {
        title: this.context.translate("_FLEET_REPORTS_GEONAME_"),
        dataIndex: "geofenceName",
        key: "geofenceName",
        width: "10%",
      },
      {
        title: this.context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        key: "vehicleNo",
        width: "10%",
      },
      {
        title: this.context.translate(
          "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
        ),
        dataIndex: "driverName",
        key: "driverName",
        width: "10%",
      },
       {
        title: this.context.translate("_FLEET_START_TIME_"),
        dataIndex: "startTime",
        key: "StartTime",
        width: "10%",
      },
       {
        title: this.context.translate("_FLEET_STOP_TIME_"),
        dataIndex: "endTime",
        key: "StopTime",
        width: "10%",
      },


      // {
      //   title: this.context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
      //   dataIndex: "visitStatus",
      //   key: "visitStatus",
      //   width: "10%",
      //   render: (s, r) => {
      //     if (parseInt(r.visitStatus) === 1) {
      //       return (
      //         <div
      //           style={{
      //             backgroundColor: "green",
      //             display: "inline-block",
      //             width: 20,
      //             height: 15,
      //           }}
      //         ></div>
      //       );
      //     } else if (parseInt(r.visitStatus) === 0) {
      //       return (
      //         <div
      //           style={{
      //             backgroundColor: "red",
      //             display: "inline-block",
      //             width: 20,
      //             height: 15,
      //           }}
      //         ></div>
      //       );
      //     }
      //   },
      // },
      {
        title: this.context.translate("_FLEET_REPORTS_GEOFENCEREPORT_INTIME_"),
        dataIndex: "inTime",
        key: "inTime",
        width: "10%",
      },
      {
        title: this.context.translate("_FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_"),
        dataIndex: "outTime",
        key: "outTime",
        width: "10%",
      },
      {
        title: this.context.translate("_ELAPSED_TIME_"),
        dataIndex: "elapsedTime",
        key: "elapsedTime",
        width: "10%",
      },
    ];

    // Hide geofenceName if filterValue is "2"
    if (filterValue === "2") {
      return allColumns.filter((col) => col.dataIndex !== "vehicleNo");
    } else {
      return allColumns.filter((col) => col.dataIndex !== "geofenceName");
    }
  };

  expandedRowRender = (record) => {
    // this.handleExpandRow(id);
    // console.log(x);
    const columns = this.getExpandedColumns();

    // const columns = [
    //   {
    //     title: this.context.translate("_FLEET_REPORTS_GEONAME_"),
    //     dataIndex: "geofenceName",
    //     key: "geofenceName",
    //     width: "10%",
    //   },
    //   {
    //     title: this.context.translate("_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"),
    //     dataIndex: "driverName",
    //     key: "driverName",
    //     width: "10%",
    //   },
    //   {
    //     title: this.context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
    //     dataIndex: "visitStatus",
    //     key: "visitStatus",
    //     width: "10%",
    //   },
    //   {
    //     title: this.context.translate("_FLEET_REPORTS_GEOFENCEREPORT_INTIME_"),
    //     dataIndex: "inTime",
    //     key: "inTime",
    //     width: "10%",
    //   },
    //   {
    //     title: this.context.translate("_FLEET_REPORTS_GEOFENCEREPORT_OUTTIME_"),
    //     dataIndex: "outTime",
    //     key: "outTime",
    //     width: "10%",
    //   },
    //   {
    //     title: this.context.translate("_ELAPSED_TIME_"),
    //     dataIndex: "elapsedTime",
    //     key: "elapsedTime",
    //     width: "10%",
    //   }
    // ];
    return (
    <div className="innerGridTbl">
      <Table
        bordered
        size="small"
        rowKey={(row) => `${record.row_id}_${row.inTime}`} // safe unique key
        style={{ padding: "20px 20px 20px 10px" }}
        columns={columns}
        dataSource={record.tableData || []}   // ✅ CORE FIX
        pagination={false}
      />
    </div>
  );
    // return (
    //   <>
    //     <div className="innerGridTbl">
    //       <Table
    //         bordered
    //         size="small"
    //         style={{ padding: "20px 20px 20px 10px" }}
    //         columns={columns}
    //         // scroll={{ x: 50 }}
    //         dataSource={this.geofenceVisitReportStore.geofenceVisitSummary}
    //         pagination={false}
    //       />
    //     </div>
    //   </>
    // );
  };

  refreshList = async () => {
    await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
    await this.showData();
  };

  triggerReport = () => {
    this.pythonMessageRef.current.show(); // show the modal
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={20}>
              <Space>
                <CompanyAutocomplete
                  onChange={this.handleChange}
                  className="searchInput"
                  allowClear={true}
                  style={{ width: 150 }}
                  // style={companyInputStyle}
                  status={this.state.Notcompany ? "error" : false}
                />
                {this.props.getUserData().isadmin === 1 && (
                  <>
                    <DeviceGroupsForVehicles
                      vehicleStore={this.vehicleStore}
                      setLoadDta={() => this.setState({ loadData: 1 })}
                      resetVehicles={() =>
                        this.setState({
                          selectedVehicles: [],
                          selectAllVehicles: false,
                        })
                      }
                    />
                  </>
                )}
        {/*
                <Select
                  style={{ width: 130 }}
                  className="searchInput"
                  // placeholder='Filter by'
                  status={this.state.filterNotSelected ? "error" : false}
                  placeholder={this.context.translate("_FILTER_BY_")}
                  onChange={(val) => {
                    // this.setState({ filterValue: val });

                    this.setState({ filterValue: val }, () => {
                      const filtered = this.state.selectedColumns.filter(
                        (col) => {
                          if (val === "1" && col.dataIndex === "vehicleNo")
                            return false;
                          if (val === "2" && col.dataIndex === "geofenceName")
                            return false;
                          return true;

                        });
                        this.setState({ column: filtered , pageNo: 1, currentPage: 1});

                    });
                    // this.setState({
                    //   filterby: val,
                    //   selectedDrivers: [],
                    //   selectedVehicles: [],
                    //   selectAllDrivers: false,
                    //   selectAllVehicles: false,
                    // });
                  }}
                >
                  <Select.Option value="1">
                    {this.context.translate("_GEOFENCE_")}
                  </Select.Option>
          
                  <Select.Option value="2">
                    {this.context.translate("_VEHICLES_")}
                  </Select.Option> 
                
                </Select>
                  */}
                {/* {this.state.filterby == "Vehicle" && ( */}
                <>
                  <Checkbox
                    checked={this.state.selectAllVehicles}
                    onChange={async (e) => {
                      await this.setState({
                        selectAllVehicles: e.target.checked,
                      });
                      if (this.state.selectAllVehicles) {
                        await this.setState({
                          Notasset: false,
                        });
                      }
                      await this.handleAllSelectVehicles();
                    }}
                  />

                  {this.context.translate("_ALL_")}

                  <Select
                    maxTagCount="responsive"
                    className="searchInput"
                    value={this.state.selectedVehicles}
                    onChange={(val) => {
                      this.setState({ selectedVehicles: val });
                      if (
                        this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                        val.length
                      ) {
                        this.setState({ selectAllVehicles: false });
                      } else {
                        this.setState({ selectAllVehicles: true });
                      }

                      if (val?.length > 1) {
                        //   console.log(val?.length > 1);
                        this.setState({ showAlertPopup: true });
                      }
                    }}
                    style={{ width: 180 }}
                    showSearch
                    status={this.state.Notasset ? "error" : false}
                    mode="multiple"
                    placeholder={this.context.translate(
                      "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                    )}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map(
                      (val) => {
                        return (
                          <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                        );
                      }
                    )}
                  </Select>
                </>
                {/* // )} */}
                {/* {this.state.filterby == "Driver" && ( */}
                <>
                  <Checkbox
                    checked={this.state.selectAllGeofenceData}
                    onChange={async (e) => {
                      await this.setState({
                        selectAllGeofenceData: e.target.checked,
                      });
                      // console.log(e.target.checked);
                      await this.handleSelectAllGeofenceData();
                    }}
                  />
                  {/* All */}
                  {this.context.translate("_ALL_")}
                  <Select
                    className="searchInput"
                    mode="multiple"
                    onSearch={this.handleSearch}
                    maxTagCount="responsive"
                    value={this.state.selectedgeofenceData}
                    onChange={(val) => {
                      this.setState({
                        selectedgeofenceData: val,
                        vehicle: false,
                      });
                      if (
                        this.geofencePOIReportStore?.geofenceData.length >
                        val.length
                      ) {
                        this.setState({
                          selectAllGeofenceData: false,
                          allGeo: 1,
                        });
                      } else {
                        this.setState({
                          selectAllGeofenceData: true,
                          allGeo: 0,
                        });
                      }
                    }}
                    // fieldNames={{ label: "name", value: "zoneId" }}
                    // placeholder=" Geofence"
                    placeholder={this.context.translate("_GEOFENCE_")}
                    optionFilterProp="children"
                    // options={this.geofencePOIReportStore?.geofenceData}
                    style={{ width: 150 }}
                    status={this.state.vehicle ? "error" : false}
                    showSearch
                    // style={inputStyle}
                    // style={vehicleInputStyle}
                    // style={this.state.array[2] ? { border: '1px solid red',width: 160,borderRadius: 8 } : { width: 160}}
                    // onSelect={(val) => console.log(val)}
                    filterOption={(inputValue, option) => {
                      if (option.children) {
                        return (
                          option.children
                            .toLowerCase()
                            .indexOf(inputValue.toLowerCase()) >= 0
                        );
                      }
                    }}
                  >
                    {this.geofencePOIReportStore?.geofenceData?.map((val) => {
                      return <Option value={val.zoneId}>{val.name}</Option>;
                    })}
                  </Select>
                </>
                {/* )} */}

                <DatePicker
                  status={this.state.fromDateNotSelected ? "error" : false}
                  defaultValue={dayjs()}
                  style={{ width: 150, borderRadius: "25px" }}
                  placeholder="From Date"
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                  onChange={(date) => {
                    // console.log(date);
                    if (date === null) {
                      this.setState({ fromDate: "" });
                    } else {
                      this.setState({ fromDate: date.format("YYYY-MM-DD") });
                    }
                  }}
                />

                <DatePicker
                  status={this.state.toDateNotSelected ? "error" : false}
                  defaultValue={dayjs()}
                  style={{ width: 150, borderRadius: "25px" }}
                  placeholder="To Date"
                  onChange={(date) => {
                    // console.log(date);
                    if (date === null) {
                      this.setState({ toDate: "" });
                    } else {
                      this.setState({ toDate: date.format("YYYY-MM-DD") });
                    }
                  }}
                  disabledDate={(current) => {
                    return current && current > dayjs();
                  }}
                />
                <Button
                  type="primary"
                  onClick={() => {
                    this.showData();
                  }}
                >
                  {/* Show */}
                  {this.context.translate("_FLEET_SHOW_BTN_")}
                </Button>
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={4}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.geofenceVisitReportStore?.geofenceVisitStore?.length >
                    0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportMenuProps}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Col>
          </Row>

          <ListTable
           rowKey="row_id" 
            key={this.state.selectedColumns.length}
            expandable={{
              expandedRowRender: this.expandedRowRender,
              onExpand: this.onExpand,
              expandedRowKeys: this.state.expandedRowKeys,
            }}
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.geofenceVisitReportStore?.total}
            // columns={this.state.column}
            columns={this.getFilteredColumns()}
            dataSource={this.geofenceVisitReportStore?.geofenceVisitStore}
            loading={this.geofenceVisitReportStore?.loading}
            onChange={this.handleTableChange}
            // {...(conf.currentFlavor === "nodeui" && {
            //   showSizeChanger: false,
            //   moreClass: "gridNum",
            // })}
          />
        </div>

        <Modal
          width={350}
          className="alert-model"
          title={
            <div>
              {" "}
              <i
                style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                class="bi bi-exclamation-triangle"
              ></i>{" "}
              {this.context.translate("_FLEET_ALERT_")}
            </div>
          }
          open={this.state.showMonthPopup}
          onOk={() => this.setState({ showMonthPopup: false })}
          onCancel={() => this.setState({ showMonthPopup: false })}
          footer={false}
        >
          {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
        </Modal>
        {
          <div>
            <PythonMessageAlert
              ref={this.pythonMessageRef}
              message={this.state.reportmessage}
            />
          </div>
        }
      </>
    );
  }
}
GeofenceVisitReportList.contextType = StoreContext;
export default observer(withRouter(GeofenceVisitReportList));
